import React, { useEffect, useState } from 'react';
import { API_URL } from '../../config';
import { useAuth } from '../../context/AuthContext';
import { TenantStats } from '../../types/admin';
import SiteLayout from '../../layouts/SiteLayout';
import Header from '../../components/Header/Header';
import Box from '../../components/Common/Box';

const TenantDashboard: React.FC = () => {
  const { token } = useAuth();
  const [stats, setStats] = useState<TenantStats | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch(`${API_URL}/tenant/stats`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.ok) {
          const data = await response.json();
          setStats(data);
        }
      } catch (error) {
        console.error('Error fetching tenant stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [token]);

  return (
    <SiteLayout>
      <Header icon='business' title={`Dashboard - ${stats?.tenant_name || 'Tenant'}`} />
      <div style={{ padding: '20px', maxWidth: '1400px', margin: '0 auto' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
            Chargement...
          </div>
        ) : !stats ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
            Aucune organisation n'est rattachée à votre compte : cet écran est réservé aux administrateurs d'un tenant.
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
            <Box>
              <div style={{ padding: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ fontSize: '40px', marginRight: '20px' }}>👥</div>
                <div>
                  <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#667eea' }}>{stats?.total_users || 0}</div>
                  <div style={{ fontSize: '14px', color: '#666' }}>Utilisateurs Internes</div>
                </div>
              </div>
            </Box>

            <Box>
              <div style={{ padding: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ fontSize: '40px', marginRight: '20px' }}>💳</div>
                <div>
                  <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#667eea', textTransform: 'capitalize' }}>{stats?.plan || 'N/A'}</div>
                  <div style={{ fontSize: '14px', color: '#666' }}>Plan Actuel</div>
                </div>
              </div>
            </Box>
          </div>
        )}
      </div>
    </SiteLayout>
  );
};

export default TenantDashboard;

